import React from "react";
import InputController from "./InputController";
import { buildClass } from "@utils/tag";

export default function PhoneInputController({ phoneVal, ...props }) {
  return (
    <InputController
      renderChild={
        <div
          className={buildClass(
            "w-[100px] min-w-[86px] bg-[#FFFFFF] p-2 h-14 rounded-lg text-base",
            "font-normal text-[#333333] flex items-center gap-3 !shadow"
          )}
        >
          {phoneVal}
        </div>
      }
      {...props}
    />
  );
}
